import { useEffect } from "react";

export const usePreventNavigation = (isOpen: boolean) => {
  useEffect(() => {
    if (!isOpen) return;

    const handleBackButton = (event: PopStateEvent) => {
      event.preventDefault();
      // Don't allow back navigation when modal is open
      window.history.pushState(null, "", window.location.href);
    };

    window.addEventListener("popstate", handleBackButton);
    window.history.pushState(null, "", window.location.href);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, [isOpen]);
};
